import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/north-star-dashboard/page.tsx");
